import { useState } from 'react';
import ResponsiveTable from '../../../../shared/components/ResponsiveTable';
import { SortedColumn } from '../../../../shared/components/ResponsiveTable/models';
import {
  getBrowserTimezone,
  toPMIFormatDateWithTime,
} from '../../../../shared/helpers';
import { LogModel } from '../../models';
import BulkActionDetailsModal from '../../ChangeLogs/BulkActionDetailsModal';
import { LogActionFormatter } from '../../LogActionFormatter';

export interface AuditLogsTableProps {
  logs: LogModel[];
}

const tableColumns = (
  onSeeMore: (log: LogModel, type: string) => void,
): SortedColumn[] => [
  {
    name: 'action',
    title: 'Action',
    cell: ({ row }) => (
      <LogActionFormatter
        onSeeMore={(type: string) => onSeeMore(row.original, type)}
        log={row.original}
      />
    ),

    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'actionGroup',
    title: 'Action Group',
    cell: ({ row }) => <span>{row.original.logType}</span>,
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'referenceId',
    title: 'Reference ID',
    cell: ({ row }) => <span>{row.original.id}</span>,
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'agreementID',
    title: 'Agreement ID',
    cell: ({ row }) => (
      <span>
        {row.original?.data?.agreementProviderId ??
          row.original?.data?.dealId ??
          row.original?.exception?.Data?.dealId}
      </span>
    ),

    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'triggeredAgainst',
    title: 'Triggered against',
    cell: (cntx) => {
      let msg = '';
      if (cntx.row.original?.data?.accountUserId) {
        msg = `Account User ID: ${cntx.row.original?.data?.accountUserId}`;
      }
      return <span data-exclude-lg>{msg}</span>;
    },
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'triggeredBy',
    title: 'Triggered by ',
    cell: (cntx) => (
      <span data-exclude-lg>{cntx.row.original?.performedBy?.personName}</span>
    ),
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'performedOn',
    title: `Date/Time (${getBrowserTimezone()})`,
    cell: (cntx) => (
      <div className={` fw-normal label`} data-testid="data-status">
        {cntx.row.original?.performedOn
          ? toPMIFormatDateWithTime(cntx.row.original?.performedOn)
          : ''}
      </div>
    ),
    width: 10,
    sortingEnabled: false,
  },
];

export default function AuditLogsTable({ logs }: AuditLogsTableProps) {
  const [showChangeLogModal, setShowChangeLogModal] = useState(false);
  const [changeLogModalData, setChangeLogModalData] = useState<LogModel>(null);
  const [changeType, setChangeType] = useState<string>(null);
  return (
    <>
      <ResponsiveTable
        data={logs}
        columns={tableColumns((log: LogModel, type: string) => {
          setShowChangeLogModal(true);
          setChangeLogModalData(log);
          setChangeType(type);
        })}
        showPagination={false}
        onSort={() => {}}
      />
      {showChangeLogModal && (
        <BulkActionDetailsModal
          type={changeType}
          log={changeLogModalData}
          onCancel={() => setShowChangeLogModal(false)}
        />
      )}
    </>
  );
}
